// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".selected{background-color:#eff8ff}.selected a{font-weight:600}", "",{"version":3,"sources":["webpack://./resources/js/components/Admin/Autocomplete.vue"],"names":[],"mappings":"AACA,UACI,wBAAJ,CAEI,YACI,eAAR","sourcesContent":["\n.selected {\n    background-color: #eff8ff;\n\n    a {\n        font-weight: 600;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
